import React, { useEffect, useState } from 'react';
import ErrorDialog from './ErrorDialog';

interface DialogState {
    open: boolean;
    message: string;
}

// Event bus for error dialog
class ErrorDialogEventBus {
    private listeners: Array<(message: string) => void> = [];

    subscribe(listener: (message: string) => void): () => void {
        this.listeners.push(listener);
        return () => {
            this.listeners = this.listeners.filter((l) => l !== listener);
        };
    }

    show(message: string): void {
        this.listeners.forEach((listener) => listener(message));
    }
}

export const errorDialogEventBus = new ErrorDialogEventBus();

const ErrorDialogManager: React.FC = () => {
    const [dialogState, setDialogState] = useState<DialogState>({
        open: false,
        message: ''
    });

    useEffect(() => {
        const unsubscribe = errorDialogEventBus.subscribe((message) => {
            setDialogState({
                open: true,
                message
            });
        });

        return unsubscribe;
    }, []);

    const handleClose = () => {
        setDialogState({
            open: false,
            message: ''
        });
    };

    return (
        <ErrorDialog
            open={dialogState.open}
            message={dialogState.message}
            onClose={handleClose}
        />
    );
};

export default ErrorDialogManager;

